import { render, staticRenderFns } from "./base.vue?vue&type=template&id=34bf5728&"
import script from "./base.vue?vue&type=script&lang=js&"
export * from "./base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34bf5728')) {
      api.createRecord('34bf5728', component.options)
    } else {
      api.reload('34bf5728', component.options)
    }
    module.hot.accept("./base.vue?vue&type=template&id=34bf5728&", function () {
      api.rerender('34bf5728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/subcomponents/base.vue"
export default component.exports